export const SET_INITIAL_STATE = Symbol("SET_INITIAL_STATE")

export const ADD_PRICE = Symbol("ADD_PRICE")
